import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { connect } from 'react-redux'
import { fetchLeaderboards } from '../../store/actions/leaderboards'
import Loading from '../common/loading'

import { createDisplayName } from '../../misc/auth-utils'
import { fetchKPIs } from '../../store/actions/kpis'

import { PieChart } from 'react-minimal-pie-chart'

// const totalIdeasTarget = 100
// const kpiGoals = {
//     publishedIdeas: totalIdeasTarget * 0.95,
//     acceptedIdeas: totalIdeasTarget * 0.5,
//     rejectedIdeas: totalIdeasTarget * 0.7,
//     implementedIdeas: totalIdeasTarget * 0.3,
//     unpublishedIdeas: totalIdeasTarget * 0.05,
//     // 'averageTimeToAcceptance': 0,
//     // 'averageTimeToImplementation': 0,
// }

export class LeaderboardsView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            topContributors: undefined,
            mostEngaging: undefined,
            mostVoted: undefined,
        }
    }

    componentDidMount() {
        this.props.fetchLeaderboards()
        this.props.fetchKPIs()
    }

    componentDidUpdate(prevProps) {
        if (this.props.leaderboards !== prevProps.leaderboards) {
            this.setState({
                topContributors: this.props.leaderboards.mostIdeasPublished,
                mostEngaging: this.props.leaderboards.mostCommentsMade,
                mostVoted: this.props.leaderboards.mostLikesReceived,
            })
        }
    }

    render() {
        if (!this.state.topContributors || !this.props.kpis) return <Loading />

        const renderTop3s = () => {
            
            return (
                <>
                    <h3 className="text-primary mb-4">Leaderboards</h3>

                    <div className="row">
                        <div className="col-sm-12 col-md-4 col-lg-4 mb-2">
                            <h4 className="font-weight-bold text-secondary  text-center">
                                <FontAwesomeIcon
                                    icon="paper-plane"
                                    className="mr-2"
                                />
                                Top Contributors
                            </h4>

                            <div className="container ml-4 mt-4">
                                {this.state.topContributors.map((u, index) => (
                                    <div key={index} className="row mb-2">
                                        <div className="col-2 my-auto">
                                            <span className="rank-circle">
                                                #{index + 1}
                                            </span>
                                        </div>
                                        <div className="col-10">
                                            <div className="container ">
                                                <p className="text-secondary mb-0">
                                                    {createDisplayName(
                                                        u.publisher
                                                    )}
                                                </p>
                                                <small>
                                                    {u.count} Submissions
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-sm-12 col-md-4 col-lg-4 mb-2 ">
                            <h4 className="font-weight-bold text-secondary text-center">
                                <FontAwesomeIcon
                                    icon="comment-alt"
                                    className="mr-2"
                                />
                                Most Engaging
                            </h4>

                            <div className="container ml-4 mt-4">
                                {this.state.mostEngaging.map((u, index) => (
                                    <div key={index} className="row mb-2">
                                        <div className="col-2 my-auto">
                                            <span className="rank-circle">
                                                #{index + 1}
                                            </span>
                                        </div>
                                        <div className="col-10">
                                            <div className="container ">
                                                <p className="text-secondary mb-0">
                                                    {createDisplayName(
                                                        u.publisher
                                                    )}
                                                </p>
                                                <small>
                                                    {u.count} Comments
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-sm-12 col-md-4 col-lg-4 mb-2">
                            <h4 className="font-weight-bold text-secondary  text-center">
                                <FontAwesomeIcon
                                    icon="thumbs-up"
                                    className="mr-2"
                                />
                                Most Voted
                            </h4>

                            <div className="container ml-4 mt-4">
                                {this.state.mostVoted.map((u, index) => (
                                    <div key={index} className="row mb-2">
                                        <div className="col-2 my-auto">
                                            <span className="rank-circle">
                                                #{index + 1}
                                            </span>
                                        </div>
                                        <div className="col-10">
                                            <div className="container ">
                                                <p className="text-secondary mb-0">
                                                    {createDisplayName(
                                                        u.publisher
                                                    )}
                                                </p>
                                                <small>
                                                    {u.count} Votes Received
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </>
            )
        }

        const renderIdeaKPIs = () => {
            if (!this.props.kpis) return <Loading />

            // const total =
            //     this.props.kpis.ideas.publishedIdeas +
            //     this.props.kpis.ideas.unpublishedIdeas
            const open = this.props.kpis.ideas.openIdeas / this.props.kpis.ideas.publishedIdeas
            const accepted = this.props.kpis.ideas.acceptedIdeas / this.props.kpis.ideas.publishedIdeas
            const rejected = this.props.kpis.ideas.rejectedIdeas / this.props.kpis.ideas.publishedIdeas
            const implemented = this.props.kpis.ideas.implementedIdeas / this.props.kpis.ideas.publishedIdeas

            // --light-gray: #949ea7;
            // --lighter-gray: #f3f3f379;
            // --gray-dark: #343a40;
            // --primary: #009999;
            // --primary-light: #00999983;
            // --primary-very-light: #0099993d;
            // --secondary: #6c757d;
            // --secondary-light: #6c757d83;
            // --secondary-very-light: #dddddd6b;

            const defaultLabelStyle = {
                fontSize: '5px',
                fontFamily: 'sans-serif',
            }
            const shiftSize = 8;

            return (
                <>
                    <h3 className="text-primary mb-4 mt-4">KPIs</h3>

                    <div className="d-flex justify-content-center">
                        <PieChart
                            style={{ height: '300px', width: '500px' }}
                            // radius="40"
                            lineWidth={15} paddingAngle={5}
                            radius={PieChart.defaultProps.radius - shiftSize}
                            data={[
                                {
                                    title: 'Open',
                                    value: open,
                                    color: '#0099993d',
                                },
                                {
                                    title: 'Accepted',
                                    value: accepted,
                                    color: '#00999983',
                                },
                                {
                                    title: 'Implemented',
                                    value: implemented,
                                    color: '#009999',
                                },
                                {
                                    title: 'Rejected',
                                    value: rejected,
                                    color: '#6c757d',
                                },
                            ]}
                            // segmentsShift={(index) => (index === 0 ? shiftSize : 0.5)}
                            label={({ dataEntry }) => dataEntry.value > 0 ? `${dataEntry.title}` : ""}
                            labelStyle={{
                                ...defaultLabelStyle,
                            }}
                            labelPosition={112}
                            animate
                        />
                        
                    </div>
                </>
            )
        }

        
        if (
            this.state.topContributors.length === 0 ||
            this.state.mostEngaging.length === 0 ||
            this.state.mostVoted.length === 0
        ) {
            return (
                <div className="container text-center">
                    <h3 className="text-primary">Aww...</h3>
                    <h5 className="text-secondary">
                        Not enough content has been produced to display the
                        leaderboards. Keep posting your ideas!{' '}
                    </h5>

                    <p
                        className="text-primary mt-4"
                        style={{
                            fontSize: '76px',
                            animation: '0.5s linear 0s infinite shakeit',
                        }}>
                        <FontAwesomeIcon icon="bullhorn" />
                    </p>
                </div>
            )
        }

        return (
            <>
                {renderTop3s()}

                {renderIdeaKPIs()}
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    //   auth: state.auth,
    leaderboards: state.leaderboards.leaderboards,
    kpis: state.kpis.kpis,
})

export default connect(mapStateToProps, { fetchLeaderboards, fetchKPIs })(
    LeaderboardsView
)
